import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _class2, _descriptor, _GuidedExpressionCompactSummaryImpl;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { ExpressionLoading } from "abreact/expression/ui/editor/impl/utils/ExpressionLoading";
import { ExpressionNotSpecified } from "abreact/expression/ui/editor/impl/utils/ExpressionNotSpecified";
import { GuidedExpressionSummaryReadOnlyGenerator } from "abreact/expression/ui/editor/readonly/GuidedExpressionSummaryReadOnlyGenerator";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbAlert, AlertLevel } from "absdk/commons/ui/popup/AbAlert";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
import { makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

/**
 * Renders a compact form of the contents of the editor, indented and with parens for clarity
 *
 * @author fgracely
 */
export let GuidedExpressionCompactSummaryImpl = (_dec = observable.ref, observer(_class = (_class2 = (_GuidedExpressionCompactSummaryImpl = class GuidedExpressionCompactSummaryImpl extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "expExpressionDefinition", _descriptor, this);
    _defineProperty(this, "guidedExpressionSummaryReadOnlyGenerator", void 0);
    _defineProperty(this, "copySuccessHandle", undefined);
    this.guidedExpressionSummaryReadOnlyGenerator = new GuidedExpressionSummaryReadOnlyGenerator(this.props.expressionDomainModel, this.props.valueRenderer);
    makeObservable(this);
  }
  render() {
    if (this.props.expExpressionDefinition != null && this.expExpressionDefinition == null) {
      return /*#__PURE__*/React.createElement(ExpressionLoading, null);
    }
    if (this.props.asText) {
      return /*#__PURE__*/React.createElement("pre", {
        className: CssUtils.composeClassNames(`guided-expression-editor-compact-readonly-text`, this.props.className)
      }, this.generateSummaryContent(true));
    } else {
      return /*#__PURE__*/React.createElement("span", {
        onKeyDown: event => this.handleKeyDown(event),
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", {
        className: CssUtils.composeClassNames(`guided-expression-editor-compact-readonly-rich`, this.props.className)
      }, this.generateSummaryContent(false)));
    }
  }
  componentDidMount() {
    this.initializeExpExpressionDefinition().then();
  }
  componentDidUpdate(previousProps) {
    if (!Expression.Definition.equals(this.props.expExpressionDefinition, previousProps.expExpressionDefinition)) {
      this.initializeExpExpressionDefinition().then();
    }
  }
  async initializeExpExpressionDefinition() {
    const {
      expExpressionDefinition,
      importVisitor
    } = this.props;
    if (expExpressionDefinition != null && importVisitor != null) {
      runInAction(() => this.expExpressionDefinition = undefined);
      const mutableExpExpressionDefinition = ObjectUtils.deepThaw(expExpressionDefinition);
      await importVisitor.finalizeRootExpExpressionNode?.(mutableExpExpressionDefinition.rootNode);
      await importVisitor.finalizeExpExpressionDefinition?.(mutableExpExpressionDefinition);
      runInAction(() => this.expExpressionDefinition = mutableExpExpressionDefinition);
    } else {
      runInAction(() => this.expExpressionDefinition = expExpressionDefinition);
    }
  }
  handleKeyDown(event) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "c") {
      event.preventDefault();
      const summaryContent = this.generateSummaryContent(true);
      if (typeof summaryContent !== "string") {
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = summaryContent;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const ret = document.execCommand("copy");
        if (ret) {
          this.copySuccessHandle = AbAlert.show({
            level: AlertLevel.SUCCESS,
            message: AbReactResources.expression_readonly_clipboard_success(),
            buttonBar: null
          });
          setTimeout(() => {
            this.copySuccessHandle && this.copySuccessHandle?.close();
            this.copySuccessHandle = undefined;
          }, 2000);
        }
      } catch (err) {
        GuidedExpressionCompactSummaryImpl.LOG.warn(`document.execCommand("copy") failed ${err.message}`);
      } finally {
        if (textArea) {
          document.body.removeChild(textArea);
        }
      }
    }
  }
  generateSummaryContent(asText) {
    const {
      expExpressionDefinition
    } = this;
    if (expExpressionDefinition == null) {
      return /*#__PURE__*/React.createElement(ExpressionNotSpecified, null);
    }
    return asText ? this.guidedExpressionSummaryReadOnlyGenerator.generateStringSummary(expExpressionDefinition) : this.guidedExpressionSummaryReadOnlyGenerator.generateRichSummary(expExpressionDefinition);
  }
}, _defineProperty(_GuidedExpressionCompactSummaryImpl, "LOG", LogUtils.getLogger(__filename)), _GuidedExpressionCompactSummaryImpl), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "expExpressionDefinition", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export let GuidedExpressionCompactSummary;
//# sourceMappingURL=GuidedExpressionCompactSummary.js.map
